import React from 'react';
import Hoowy from "../component/page/Hoowy";

const map = [
    <Hoowy/>,
];

export default map;
